import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NotificationService } from '../../../services/notification.service';
import { OverlayWindowService } from '../../single-window/shared/overlay-window.service';
import { HttpClient } from '../../../services/http.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-news-edit',
    templateUrl: './news-edit.component.html',
    styleUrls: ['./news-edit.component.scss'],
    standalone: false
})
export class NewsEditComponent implements OnInit {

  @Input() public news_date = new DatePipe('en-US').transform(Date.now(), 'dd.MM.yyyy');
  @Input() public news_description = '';
  @Input() public news_id;
  @Input() public news_title = '';
  @Input() public is_archive = '';
  @Input() public always_show = '';
  @Input() public news_url = '';
  @Input() public file = '';
  @Input() public is_view_news_list = '';
  @Input() public is_view_vitrine = '';
  @Input() public tags: { id: number; caption: string }[] = [];
  @Input() public public_status = 'crm';
  @Output() public onEdit: EventEmitter<any> = new EventEmitter<any>();

  @Input() public dictTags;

  newsTagIds: number[] = [];

  public form: UntypedFormGroup;

  constructor(private http: HttpClient, private overlayWindowService: OverlayWindowService,
              private fb: UntypedFormBuilder, private notify: NotificationService,
              private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.http.post('News.get_tags').subscribe(data => {

      // Создаем форму после загрузки опций
      this.form = this.fb.group({
        'news_title': [this.news_title, Validators.required],
        'news_description': [this.news_description, Validators.required],
        'news_link': [this.news_url, Validators.required],
        'news_date': [this.news_date, Validators.required],
        'public_status': [this.public_status, Validators.required],
        'always_show': [this.always_show, Validators.required],
        'is_archive': [this.is_archive, Validators.required],
        'is_view_news_list': [this.is_view_news_list],
        'is_view_vitrine': [this.is_view_vitrine],
        'file': [this.file],
        'tags': [this.tags.map(t => t.id ? t.id.toString() : null)],  // Устанавливаем сразу
      });
    });
  }

  onSubmit() {
    const data = {
      'news_id': this.news_id,
      'data': {
        'news_title': this.form.value.news_title,
        'news_description': this.form.value.news_description,
        'news_url': this.form.value.news_link,
        'news_date': this.form.value.news_date,
        'always_show': this.form.value.always_show,
        'is_archive': this.form.value.is_archive,
        'public_status': this.form.value.public_status,
        'is_view_news_list': this.form.value.is_view_news_list,
        'is_view_vitrine': this.form.value.is_view_vitrine,
        'file': this.form.value.file,
        'tags': this.form.value.tags,
      }
    };
    this.http.post('News.edit', data).subscribe(
      response => {
        const title = this.form.value.news_title;
        this.notify.notifySuccess('Новость успешно отредактирована', title, 5000);
        this.onEdit.emit({'value': title});
        this.overlayWindowService.closeHost();
      },
      error => this.notify.notifyError('Ошибка', error, 5000)
    );
  }

  onCancelClick() {
    this.overlayWindowService.closeHost();
  }

}
